var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layoutOne"},[_c('ots-main-title',{attrs:{"mainTopBtn":_vm.mainTopBtn}}),_c('div',{staticClass:"main"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }